import React from 'react'
import { Tag, Tooltip } from 'antd'
import i18next from 'i18next'
import { MailOutlined } from '@ant-design/icons'
import { IQrScansOriginTableItem, ITrusteeTableItem } from '../../../reducers/jobs/actions'
import { Organization } from '../../../reducers/user/userActions'

/**
 * Zdielane render funkcie stlpcov tabulky zakaziek.
 * Pouziva ich obycajna stranka Prace aj super-org tabulka - aby formatovanie
 * neexistovalo dvakrat a oprava bugu platila na oboch miestach.
 */

export const renderTrustees = (value: ITrusteeTableItem[]) => (value || []).map((trustee) => (
	<Tooltip
		key={trustee.email} placement="topLeft" title={ trustee.sendEmail
			? <div>{i18next.t('pages:Odosielať potvrdzujúci email: ')} <b style={{ color: 'green' }}>{ i18next.t('pages:Aktívne') }</b> / { i18next.t('pages:Neaktívne') }</div>
			: <div>{i18next.t('pages:Odosielať potvrdzujúci email: ')} { i18next.t('pages:Aktívne') } / <b style={{ color: 'red' }}>{ i18next.t('pages:Neaktívne') }</b></div> }
	>
		<Tag>
			{`${trustee.email}`}<span> </span>
			<MailOutlined style={ {
				marginRight: 6,
				color: trustee.sendEmail ? 'green' : 'red'
			} }/>
		</Tag>
	</Tooltip>
))

export const renderQrScanDuration = (value: IQrScansOriginTableItem | null) => (
	<div className={'flex justify-center'}>
		<div className={'text-center'}>{value?.duration}</div>
	</div>
)

// pouziva sa len v super-org rezime, ale patri sem k ostatnym renderom stlpcov zakaziek
export const renderOrganizationTag = (value: Organization | null) => (
	value?.name ? <Tag color={'blue'}>{value.name}</Tag> : <span>-</span>
)

export const renderQrScanLastService = (value: IQrScansOriginTableItem | null) => (
	<div className={'flex flex-row-reverse mr-3'}>
		<div>
			<div>{value?.from} - {value?.to}</div>
			<div className={'text-gray-400 text-xs text-left'}>{value?.date}</div>
		</div>
	</div>
)
